import { register } from '!/repository'
import { model as sessionModel } from '$/session'
import { combine, createEvent, sample } from 'effector'
import { moviesPurchasedEntityModel } from '~/entities/movies/purchased'
import { nay } from '~/shared/helpers'
import { libraryGridPurchasedMoviesWidget } from '~/widgets/library/grid/purchased/movies'
import { $libraryPurchasedMoviesTranslations } from './translations'

export const initLibraryPurchasedMoviesPage = createEvent()
export const leftLibraryPurchasedMoviesPage = createEvent()

sample({
  clock: initLibraryPurchasedMoviesPage,
  target: libraryGridPurchasedMoviesWidget.loadGridPurchasedMovies,
})

export const $isLibraryPurchasedMoviesEmptyPage = combine(
  moviesPurchasedEntityModel.$purchasedVodsGrid,
  (purchasedVodsGrid) => purchasedVodsGrid && !purchasedVodsGrid.content.length
)

sample({
  source: leftLibraryPurchasedMoviesPage,
  target: moviesPurchasedEntityModel.resetPurchasedVodsGrid,
})

sample({
  source: sessionModel.$authenticated,
  filter: nay,
  target: moviesPurchasedEntityModel.resetPurchasedVodsGrid,
})

register(
  $libraryPurchasedMoviesTranslations,
  '$libraryPurchasedMoviesTranslations'
)
register(
  moviesPurchasedEntityModel.$purchasedVodsGridFormatted,
  '$library/purchased/movies/purchasedVodsGridFormatted'
)
register(
  $isLibraryPurchasedMoviesEmptyPage,
  '$isLibraryPurchasedMoviesEmptyPage'
)
register(
  libraryGridPurchasedMoviesWidget.loadMoreGridPurchasedMovies,
  'loadMoreGridPurchasedMovies'
)
